import Vue from "vue";
const routes = [
    { path: "/" },

    /**
     * 管理者向け
     */
    {
        path: "/login",
        name: "login",
        component: () => import(/* webpackChunkName: "login" */ "@/views/LoginScreen.vue"),
    },

    {
        path: "/password-forgot",
        name: "password-forgot",
        component: () => import(/* webpackChunkName: "password-forgot" */ "@/views/PasswordForgotScreen.vue"),
    },
    {
        path: "/password-reset",
        name: "password-reset",
        component: () => import(/* webpackChunkName: "password-reset" */ "@/views/PasswordResetScreen.vue"),
    },
    {
        path: "/password-set",
        name: "password-set",
        component: () => import(/* webpackChunkName: "password-set" */ "@/views/PasswordSetScreen.vue"),
    },

    {
        path: "/admin/companies",
        name: "admin-companies",
        component: () =>
            import(/* webpackChunkName: "admin-companies-list" */ "@/views/admin/companies/CompanyListScreen.vue"),
        meta: { requiresAuth: true, canAccessRole: ["admin"] },
    },
    {
        path: "/companies",
        name: "companies",
        component: () => import(/* webpackChunkName: "company-list" */ "@/views/company/companies/CompanyListScreen.vue"),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/admin/companies/create",
        name: "admin-company-create",
        components: {
            default: () =>
                import(/* webpackChunkName: "admin-companies-list" */ "@/views/admin/companies/CompanyListScreen.vue"),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "admin-companies-create" */ "@/views/admin/companies/CompanyCreateScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin"] },
    },
    {
        path: "/admin/companies/:companyId",
        name: "admin-company-detail",
        components: {
            default: () =>
                import(/* webpackChunkName: "admin-companies-list" */ "@/views/admin/companies/CompanyListScreen.vue"),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "admin-company-detail" */ "@/views/admin/companies/CompanyDetailScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin"] },
    },
    {
        path: "/admin/companies/:companyId/delete",
        name: "admin-company-delete",
        components: {
            default: () =>
                import(/* webpackChunkName: "admin-companies-list" */ "@/views/admin/companies/CompanyListScreen.vue"),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "admin-companies-delete" */ "@/views/admin/companies/CompanyDeleteScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin"] },
    },

    {
        path: "/admin/companies/:companyId/sensors/delete",
        name: "admin-company-sensor-delete",
        components: {
            default: () =>
                import(/* webpackChunkName: "company-sensors-list" */ "@/views/company/sensors/SensorListScreen.vue"),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "admin-company-sensor-delete" */ "@/views/admin/sensors/SensorDeleteScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin"] },
    },

    {
        path: "/admin/companies/:companyId/gateways/delete",
        name: "admin-company-gateway-delete",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-gateways-list" */ "@/views/company/gateways/GatewayListScreen.vue"
                ),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "admin-company-gateway-delete" */ "@/views/admin/gateways/GatewayDeleteScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin"] },
    },

    {
        path: "/admin/companies/:companyId/tablets/delete",
        name: "admin-company-tablet-delete",
        components: {
            default: () =>
                import(/* webpackChunkName: "company-tablets-list" */ "@/views/company/tablets/TabletListScreen.vue"),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "admin-company-tablet-delete" */ "@/views/admin/tablets/TabletDeleteScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin"] },
    },

    {
        path: "/admin/secondhands",
        name: "admin-secondhands",
        components: {
            default: () =>
                import(/* webpackChunkName: "admin-companies-list" */ "@/views/admin/companies/CompanyListScreen.vue"),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "admin-secondhands-list" */ "@/views/admin/secondhands/SecondhandListScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin"] },
    },

    /**
     * 会社管理者向け
     */

    {
        path: "/company/instructions",
        name: "company-instructions",
        component: () =>
            import(
                /* webpackChunkName: "company-instructions" */ "@/views/company/instructions/InstructionsScreen.vue"
            ),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/analytics",
        name: "company-analytics-detail",
        component: () =>
            import(
                /* webpackChunkName: "company-analytics-detail" */ "@/views/company/analytics/AnalyticsDetailScreen-new.vue"
            ),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },

    {
        path: "/company/gateways",
        name: "company-gateways",
        component: () =>
            import(/* webpackChunkName: "company-gateways-list" */ "@/views/company/gateways/GatewayListScreen.vue"),
        props: (route: any) => ({ vacanCompanyId: route.params.vacanCompanyId }),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/gateways/bulk-upload",
        name: "company-gateways-bulk-upload",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-gateways-list" */ "@/views/company/gateways/GatewayListScreen.vue"
                ),
            fadex: () =>
                import(
                    /* webpackChunkName: "company-gateways-bulk-upload" */ "@/views/company/gateways/GatewayBulkUploadScreen.vue"
                ),
            fadey: Vue.extend({}),
        },
        props: (route: any) => ({ vacanCompanyId: route.params.vacanCompanyId }),
        meta: { requiresAuth: true, canAccessRole: ["admin"] },
    },

    {
        path: "/company/sensors",
        name: "company-sensors",
        component: () =>
            import(/* webpackChunkName: "company-sensors-list" */ "@/views/company/sensors/SensorListScreen.vue"),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/sensors/bulk-upload",
        name: "company-sensors-bulk-upload",
        components: {
            default: () =>
                import(/* webpackChunkName: "company-sensors-list" */ "@/views/company/sensors/SensorListScreen.vue"),
            fadex: () =>
                import(
                    /* webpackChunkName: "company-sensors-bulk-upload" */ "@/views/company/sensors/SensorBulkUploadScreen.vue"
                ),
            fadey: Vue.extend({}),
        },
        props: (route: any) => ({ vacanCompanyId: route.params.vacanCompanyId }),
        meta: { requiresAuth: true, canAccessRole: ["admin"] },
    },

    {
        path: "/company/tablets",
        name: "company-tablets",
        component: () =>
            import(/* webpackChunkName: "company-tablets-list" */ "@/views/company/tablets/TabletListScreen.vue"),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/tablets/bulk-upload",
        name: "company-tablets-bulk-upload",
        components: {
            default: () =>
                import(/* webpackChunkName: "company-tablets-list" */ "@/views/company/tablets/TabletListScreen.vue"),
            fadex: () =>
                import(
                    /* webpackChunkName: "company-tablets-bulk-upload" */ "@/views/company/tablets/TabletBulkUploadScreen.vue"
                ),
            fadey: Vue.extend({}),
        },
        props: (route: any) => ({ vacanCompanyId: route.params.vacanCompanyId }),
        meta: { requiresAuth: true, canAccessRole: ["admin"] },
    },

    {
        path: "/company/toilets",
        name: "company-toilets",
        component: () =>
            import(/* webpackChunkName: "company-toilets-list" */ "@/views/company/toilets/ToiletListScreen.vue"),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/toilets/:toiletId",
        name: "company-toilet-detail",
        components: {
            default: () =>
                import(/* webpackChunkName: "company-toilets-list" */ "@/views/company/toilets/ToiletListScreen.vue"),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-toilet-detail" */ "@/views/company/toilets/ToiletDetailScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/toilets/create",
        name: "company-toilet-create",
        components: {
            default: () =>
                import(/* webpackChunkName: "company-toilets-list" */ "@/views/company/toilets/ToiletListScreen.vue"),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-toilet-create" */ "@/views/company/toilets/ToiletCreateScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/toilets/:toiletId/delete",
        name: "company-toilet-delete",
        components: {
            default: () =>
                import(/* webpackChunkName: "company-toilets-list" */ "@/views/company/toilets/ToiletListScreen.vue"),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-toilet-delete" */ "@/views/company/toilets/ToiletDeleteScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },

    {
        path: "/company/websites",
        name: "company-websites",
        component: () =>
            import(/* webpackChunkName: "company-websites-list" */ "@/views/company/websites/WebsiteListScreen.vue"),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/websites/create",
        name: "company-website-create",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-websites-list" */ "@/views/company/websites/WebsiteListScreen.vue"
                ),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-website-create" */ "@/views/company/websites/WebsiteCreateScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/websites/:websiteId",
        name: "company-website-detail",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-websites-list" */ "@/views/company/websites/WebsiteListScreen.vue"
                ),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-website-detail" */ "@/views/company/websites/WebsiteDetailScreen.vue"
                ),
        },
        props: (route: any) => ({ website: route.params.website }),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/websites/:websiteId/delete",
        name: "company-website-delete",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-websites-list" */ "@/views/company/websites/WebsiteListScreen.vue"
                ),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-website-delete" */ "@/views/company/websites/WebsiteDeleteScreen.vue"
                ),
        },
        props: (route: any) => ({ website: route.params.website }),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/websites/:websiteId/url",
        name: "company-website-url-detail-from-list",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-websites-list" */ "@/views/company/websites/WebsiteListScreen.vue"
                ),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-website-url-detail" */ "@/views/company/websites/urls/WebsiteUrlDetailScreen.vue"
                ),
        },
        props: (route: any) => ({ website: route.params.website }),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },

    {
        path: "/company/websites/:websiteId/public-places",
        name: "company-website-public-places",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-websites-list" */ "@/views/company/websites/WebsiteListScreen.vue"
                ),
            fadex: () =>
                import(
                    /* webpackChunkName: "company-website-public-place-list" */ "@/views/company/websites/public-places/WebsitePublicPlaceListScreen.vue"
                ),
            fadey: Vue.extend({}),
        },
        props: (route: any) => ({ website: route.params.website }),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/websites/:websiteId/public-places/edit",
        name: "company-website-public-place-edit",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-websites-list" */ "@/views/company/websites/WebsiteListScreen.vue"
                ),
            fadex: () =>
                import(
                    /* webpackChunkName: "company-website-public-place-list" */ "@/views/company/websites/public-places/WebsitePublicPlaceListScreen.vue"
                ),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-website-public-place-edit" */ "@/views/company/websites/public-places/WebsitePublicPlaceEditScreen.vue"
                ),
        },
        props: (route: any) => ({ website: route.params.website }),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/websites/:websiteId/detail-url",
        name: "company-website-url-detail-from-detail",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-websites-list" */ "@/views/company/websites/WebsiteListScreen.vue"
                ),
            fadex: () =>
                import(
                    /* webpackChunkName: "company-website-public-place-list" */ "@/views/company/websites/public-places/WebsitePublicPlaceListScreen.vue"
                ),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-website-url-detail" */ "@/views/company/websites/urls/WebsiteUrlDetailScreen.vue"
                ),
        },
        props: (route: any) => ({ website: route.params.website }),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },

    {
        path: "/company/users",
        name: "company-users",
        component: () =>
            import(
                /* webpackChunkName: "company-users-list" */ "@/views/company/company-users/CompanyUserListScreen.vue"
            ),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/users/create",
        name: "company-user-create",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-users-list" */ "@/views/company/company-users/CompanyUserListScreen.vue"
                ),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-users-create" */ "@/views/company/company-users/CompanyUserCreateScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/users/:companyUserId",
        name: "company-user-detail",
        component: () =>
            import(
                /* webpackChunkName: "company-user-detail" */ "@/views/company/company-users/CompanyUserDetailScreen.vue"
            ),
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-users-list" */ "@/views/company/company-users/CompanyUserListScreen.vue"
                ),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-user-detail" */ "@/views/company/company-users/CompanyUserDetailScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/users/:companyUserId/delete",
        name: "company-user-delete",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-users-list" */ "@/views/company/company-users/CompanyUserListScreen.vue"
                ),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-user-delete" */ "@/views/company/company-users/CompanyUserDeleteScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },

    {
        path: "/company/tenant-users",
        name: "company-tenant-users",
        component: () =>
            import(
                /* webpackChunkName: "company-tenant-users-list" */ "@/views/company/tenant-users/TenantUserListScreen.vue"
            ),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/tenant-users/create",
        name: "company-tenant-user-create",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-tenant-users-list" */ "@/views/company/tenant-users/TenantUserListScreen.vue"
                ),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-tenant-user-create" */ "@/views/company/tenant-users/TenantUserCreateScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/tenant-users/:tenantUserId",
        name: "company-tenant-user-detail",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-tenant-users-list" */ "@/views/company/tenant-users/TenantUserListScreen.vue"
                ),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-tenant-user-detail" */ "@/views/company/tenant-users/TenantUserDetailScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/tenant-users/:tenantUserId/delete",
        name: "company-tenant-user-delete",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-tenant-users-list" */ "@/views/company/tenant-users/TenantUserListScreen.vue"
                ),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-tenant-user-delete" */ "@/views/company/tenant-users/TenantUserDeleteScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },

    {
        path: "/company/toilets/:toiletId/boxes",
        name: "company-toilet-boxes",
        component: () =>
            import(
                /* webpackChunkName: "company-toilet-box-list" */ "@/views/company/toilets/boxes/ToiletBoxListScreen.vue"
            ),
        components: {
            default: () =>
                import(/* webpackChunkName: "company-toilets-list" */ "@/views/company/toilets/ToiletListScreen.vue"),
            fadex: () =>
                import(
                    /* webpackChunkName: "company-toilet-box-list" */ "@/views/company/toilets/boxes/ToiletBoxListScreen.vue"
                ),
            fadey: Vue.extend({}),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/toilets/:toiletId/boxes/:boxId",
        name: "company-toilet-box-detail",
        components: {
            default: () =>
                import(/* webpackChunkName: "company-toilets-list" */ "@/views/company/toilets/ToiletListScreen.vue"),
            fadex: () =>
                import(
                    /* webpackChunkName: "company-toilet-box-list" */ "@/views/company/toilets/boxes/ToiletBoxListScreen.vue"
                ),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-toilet-box-detail" */ "@/views/company/toilets/boxes/ToiletBoxDetailScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/toilets/:toiletId/boxes/create",
        name: "company-toilet-box-create",
        components: {
            default: () =>
                import(/* webpackChunkName: "company-toilets-list" */ "@/views/company/toilets/ToiletListScreen.vue"),
            fadex: () =>
                import(
                    /* webpackChunkName: "company-toilet-box-list" */ "@/views/company/toilets/boxes/ToiletBoxListScreen.vue"
                ),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-toilet-box-create" */ "@/views/company/toilets/boxes/ToiletBoxCreateScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/toilets/:toiletId/boxes/:boxId",
        name: "company-toilet-box-delete",
        components: {
            default: () =>
                import(/* webpackChunkName: "company-toilets-list" */ "@/views/company/toilets/ToiletListScreen.vue"),
            fadex: () =>
                import(
                    /* webpackChunkName: "company-toilet-box-list" */ "@/views/company/toilets/boxes/ToiletBoxListScreen.vue"
                ),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-toilet-box-delete" */ "@/views/company/toilets/boxes/ToiletBoxDeleteScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },

    {
        path: "/company/alert-destinations",
        name: "company-alert-destinations",
        component: () =>
            import(
                /* webpackChunkName: "company-alert-destinations-list" */ "@/views/company/alert-destinations/AlertDestinationListScreen.vue"
            ),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/alert-destinations/create",
        name: "company-alert-destination-create",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-alert-destinations-list" */ "@/views/company/alert-destinations/AlertDestinationListScreen.vue"
                ),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-alert-destination-create" */ "@/views/company/alert-destinations/AlertDestinationCreateScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/alert-destinations/:alertDestinationId",
        name: "company-alert-destination-detail",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-alert-destinations-list" */ "@/views/company/alert-destinations/AlertDestinationListScreen.vue"
                ),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-alert-destination-detail" */ "@/views/company/alert-destinations/AlertDestinationDetailScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/alert-destinations/:alertDestinationId/delete",
        name: "company-alert-destination-delete",
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "company-alert-destinations-list" */ "@/views/company/alert-destinations/AlertDestinationListScreen.vue"
                ),
            fadex: Vue.extend({}),
            fadey: () =>
                import(
                    /* webpackChunkName: "company-alert-destination-delete" */ "@/views/company/alert-destinations/AlertDestinationDeleteScreen.vue"
                ),
        },
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },

    {
        path: "/company/alert-setting",
        name: "company-alert-settings",
        component: () =>
            import(
                /* webpackChunkName: "company-alert-settings-list" */ "@/views/company/alert-settings/AlertSettingListScreen.vue"
            ),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },

    {
        path: "/company/alerts",
        name: "company-alerts",
        component: () => import(/* webpackChunkName: "company-alert" */ "@/views/company/alerts/AlertListScreen.vue"),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },
    {
        path: "/company/alerts/long-stay",
        name: "company-long-stay-alerts",
        component: () =>
            import(
                /* webpackChunkName: "company-long-stay-alert" */ "@/views/company/alerts/AlertLongStayListScreen.vue"
            ),
        meta: { requiresAuth: true, canAccessRole: ["admin", "company"] },
    },

    /**
     * エラー
     */
    {
        path: "/404",
        name: "not-found",
        component: () => import(/* webpackChunkName: "not-found" */ "@/views/NotFoundScreen.vue"),
    },

    {
        path: "*",
        redirect: "404",
    },
];

export default routes;
